export default __webpack_public_path__ + "static/media/anteng.6e0b3a3c.png";